import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { IL_LISTESI, getIlceler } from "@/lib/turkiye";

/**
 * Bağlı il/ilçe seçimi.
 * - İl seçilince o ile ait ilçeler yüklenir.
 * - İl değişince ilçe otomatik temizlenir.
 * - İl seçilmeden ilçe pasiftir.
 */
export function LocationSelect({
  city = "",
  district = "",
  onChange,
  required = false,
  cityTestId = "city-select",
  districtTestId = "district-select",
}) {
  const ilceler = getIlceler(city);

  const handleCity = (v) => onChange(v, ""); // il değişti -> ilçe temizlenir
  const handleDistrict = (v) => onChange(city, v);

  return (
    <>
      <div className="space-y-1.5">
        <Label>İl{required && <span className="text-red-500"> *</span>}</Label>
        <Select value={city} onValueChange={handleCity}>
          <SelectTrigger data-testid={cityTestId}><SelectValue placeholder="İl seçiniz" /></SelectTrigger>
          <SelectContent className="max-h-72">
            {IL_LISTESI.map((il) => <SelectItem key={il} value={il}>{il}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label>İlçe</Label>
        <Select value={district} onValueChange={handleDistrict} disabled={!city}>
          <SelectTrigger data-testid={districtTestId}>
            <SelectValue placeholder={city ? "İlçe seçiniz" : "Önce il seçiniz"} />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {ilceler.map((ilce) => <SelectItem key={ilce} value={ilce}>{ilce}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </>
  );
}
